<template>
  <WebChapterTemplate
    page-title="新闻与传播研究所科研成果获奖情况"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <div class="awards-page">
      <section
        v-for="section in sections"
        :key="section.key"
        class="card awards-section"
      >
        <div class="section-header">
          <h3 class="section-name">{{ section.title }}</h3>
        </div>

        <div class="table-wrap">
          <table class="awards-table">
            <thead>
              <tr>
                <th v-for="header in headers" :key="header">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in section.rows" :key="`${section.key}-${index}`">
                <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                  <span class="cell-preline">{{ cell }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

    </div>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

const SECTION_DEFS = [
  {
    key: 'cass-awards',
    title: '新闻与传播研究所获中国社会科学院优秀科研成果奖作品目录',
    page: 27,
    startTop: 278,
    endTop: 508
  },
  {
    key: 'young-awards',
    title: '新闻与传播研究所获中国社会科学院青年优秀成果奖作品目录',
    page: 27,
    startTop: 559,
    endTop: 673
  },
  {
    key: 'retired-awards',
    title: '新闻与传播研究所获中国社会科学院离退休人员优秀科研成果奖作品目录',
    page: 27,
    startTop: 725,
    endTop: 880
  },
  {
    key: 'other-awards',
    title: '其他重要奖项目录',
    page: 28,
    startTop: 273,
    endTop: 848
  }
];

export default {
  name: 'LanhuKeyanchengguohuojiang',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      headers: ['获奖届别', '成果名称', '作者', '成果形式', '发表单位', '发表时间', '获奖等级'],
      sections: []
    };
  },
  mounted() {
    this.loadAwardTables();
  },
  methods: {
    detectColumn(left) {
      if (left < 270) return 0;
      if (left < 620) return 1;
      if (left < 720) return 2;
      if (left < 800) return 3;
      if (left < 950) return 4;
      if (left < 1080) return 5;
      return 6;
    },
    mergeCell(base, extra) {
      if (!base) return extra;
      if (!extra) return base;
      return `${base}\n${extra}`;
    },
    normalizeText(text = '') {
      return text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    },
    buildRows(pageNode, startTop, endTop) {
      const texts = Array.from(pageNode.querySelectorAll('text'))
        .map((node) => ({
          top: Number(node.getAttribute('top') || 0),
          left: Number(node.getAttribute('left') || 0),
          text: this.normalizeText(node.textContent || '')
        }))
        .filter((node) => node.text && node.top >= startTop && node.top < endTop)
        .sort((a, b) => (a.top - b.top) || (a.left - b.left));

      const groups = [];
      texts.forEach((node) => {
        const last = groups[groups.length - 1];
        if (!last || node.top - last.top > 14) {
          groups.push({ top: node.top, items: [node] });
          return;
        }
        last.items.push(node);
      });

      const rows = [];
      groups.forEach((group) => {
        const cells = ['', '', '', '', '', '', ''];
        group.items.forEach((item) => {
          const column = this.detectColumn(item.left);
          cells[column] = this.mergeCell(cells[column], item.text);
        });

        const filledCount = cells.filter(Boolean).length;
        const lastRow = rows[rows.length - 1];

        if (lastRow && group.top - lastRow.top <= 18 && filledCount <= 2) {
          cells.forEach((value, index) => {
            if (value) {
              lastRow.cells[index] = this.mergeCell(lastRow.cells[index], value);
            }
          });
          return;
        }

        rows.push({ top: group.top, cells });
      });

      return rows
        .map((row) => row.cells)
        .filter((cells) => cells.some(Boolean));
    },
    async loadAwardTables() {
      try {
        const response = await fetch('/pdf/keyanchengguohuojiang/layout.xml', { cache: 'no-cache' });
        if (!response.ok) {
          return;
        }

        const xmlText = await response.text();
        const xmlDoc = new DOMParser().parseFromString(xmlText, 'application/xml');
        const pageMap = {};

        Array.from(xmlDoc.querySelectorAll('page')).forEach((pageNode) => {
          pageMap[Number(pageNode.getAttribute('number'))] = pageNode;
        });

        this.sections = SECTION_DEFS.map((def) => ({
          ...def,
          rows: this.buildRows(pageMap[def.page], def.startTop, def.endTop)
        }));

      } catch (error) {
        this.sections = [];
      }
    }
  }
};
</script>

<style scoped>
.awards-page {
  display: grid;
  gap: 24px;
}

.card {
  padding: 28px 30px;
  border-radius: 16px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.84), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, #fff, rgba(253, 250, 246, 0.96));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.section-header {
  margin-bottom: 18px;
}

.section-name {
  margin: 0;
  color: #f25c19;
  font-size: 22px;
  line-height: 1.35;
}

.table-wrap {
  overflow-x: auto;
}

.awards-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 980px;
  background: #fff;
}

.awards-table th,
.awards-table td {
  padding: 14px 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  vertical-align: top;
  text-align: left;
}

.awards-table th {
  background: rgba(242, 92, 25, 0.08);
  color: #8e3010;
  font-size: 15px;
  font-weight: 700;
}

.awards-table td {
  color: #4c3a2f;
  font-size: 15px;
  line-height: 1.8;
}

.cell-preline {
  white-space: pre-line;
}

@media (max-width: 960px) {
  .card {
    padding: 22px 18px;
  }

  .section-header {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
